'use strict';
// write your code here
var populationSpans = document.querySelectorAll('.population');
var numbers = Array.from(populationSpans).map(function(span) {
    var value = span.textContent.replace(/[^\d]/g, '');
    var num = Number(value);
    return isNaN(num) ? 0 : num;
});
var total = numbers.reduce(function(acc, val) {
    return acc + val;
}, 0);
var average = numbers.length ? total / numbers.length : 0;
var formattedTotal = total.toLocaleString();
var formattedAverage = average.toLocaleString();
var totalElem = document.querySelector('.total-population');
if (totalElem) totalElem.textContent = formattedTotal;
var averageElem = document.querySelector('.average-population');
if (averageElem) averageElem.textContent = formattedAverage;

//# sourceMappingURL=js_get_data_DOM.2a62a587.js.map
